import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const RefreshIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 32, height = 32, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M26.6666 14.6664C26.3405 12.3201 25.252 10.146 23.5688 8.4791C21.8855 6.81221 19.7009 5.745 17.3515 5.44184C15.002 5.13869 12.6181 5.61641 10.5669 6.80143C8.51563 7.98645 6.91092 9.81302 5.99992 11.9998M5.33325 6.66644V11.9998H10.6666M5.33325 17.3331C5.65933 19.6795 6.74783 21.8535 8.43107 23.5204C10.1143 25.1873 12.2989 26.2545 14.6484 26.5577C16.9978 26.8608 19.3818 26.3831 21.433 25.1981C23.4842 24.0131 25.0889 22.1865 25.9999 19.9998M26.6666 25.3331V19.9998H21.3333"
          stroke="white"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
